<template>
  <CountryPage country="cambodia" />
</template>